// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: CkB-U85X0Chb
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicEscrowPaymentsPagePreviewAch.module.css"; // plasmic-import: CkB-U85X0Chb/css
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: sgRe6pjmwXSr/icon
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: pAewef34g4ck/icon
import Line1Icon from "./icons/PlasmicIcon__Line1"; // plasmic-import: MRg3okKdNvAo/icon
import Layer11Icon from "./icons/PlasmicIcon__Layer11"; // plasmic-import: z3YAObc8gkKH/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: jmxAADuTvJ3W/icon

createPlasmicElementProxy;

export const PlasmicEscrowPaymentsPagePreviewAch__VariantProps = new Array();

export const PlasmicEscrowPaymentsPagePreviewAch__ArgProps = new Array(
  "sendText",
  "contractName",
  "amount",
  "milestoneName",
  "merchantName",
  "escrowDeposit",
  "milestoneOrContract"
);

const $$ = {};

function PlasmicEscrowPaymentsPagePreviewAch__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__e7Fz3)}>
            <Icon4Icon
              data-plasmic-name={"goBackArrow"}
              data-plasmic-override={overrides.goBackArrow}
              className={classNames(projectcss.all, sty.goBackArrow)}
              role={"img"}
            />

            <div
              data-plasmic-name={"goBackText"}
              data-plasmic-override={overrides.goBackText}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.goBackText
              )}
            >
              {"Go Back"}
            </div>
            <div
              data-plasmic-name={"sendButton"}
              data-plasmic-override={overrides.sendButton}
              className={classNames(projectcss.all, sty.sendButton)}
            >
              <div
                data-plasmic-name={"sendText"}
                data-plasmic-override={overrides.sendText}
                className={classNames(projectcss.all, sty.sendText)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Send",
                  value: args.sendText,
                  className: classNames(sty.slotTargetSendText)
                })}
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox__mjmqT)}>
              <div
                data-plasmic-name={"companyName"}
                data-plasmic-override={overrides.companyName}
                className={classNames(projectcss.all, sty.companyName)}
              >
                {renderPlasmicSlot({
                  defaultContents: "",
                  value: args.merchantName,
                  className: classNames(sty.slotTargetMerchantName)
                })}
              </div>
              <div
                data-plasmic-name={"rectangle29"}
                data-plasmic-override={overrides.rectangle29}
                className={classNames(projectcss.all, sty.rectangle29)}
              >
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__sxXl9)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: (
                        <div
                          className={classNames(
                            projectcss.all,
                            projectcss.__wab_text,
                            sty.text___8XzCh
                          )}
                        >
                          {"Requested Milestone Deposit: $900.00"}
                        </div>
                      ),

                      value: args.escrowDeposit,
                      className: classNames(sty.slotTargetEscrowDeposit)
                    })}
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___24Iou)}
                  >
                    {renderPlasmicSlot({
                      defaultContents: "Milestone 1: Initial Setup",
                      value: args.milestoneOrContract,
                      className: classNames(sty.slotTargetMilestoneOrContract)
                    })}
                  </div>
                  <Line2Icon
                    className={classNames(projectcss.all, sty.svg__f8BrS)}
                    role={"img"}
                  />

                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View Full Contract Details  >"}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"rectangle28"}
                data-plasmic-override={overrides.rectangle28}
                className={classNames(projectcss.all, sty.rectangle28)}
              >
                <div
                  data-plasmic-name={"figmaPaste2"}
                  data-plasmic-override={overrides.figmaPaste2}
                  className={classNames(projectcss.all, sty.figmaPaste2)}
                >
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__oVxLh
                    )}
                  >
                    {"Deposit Milestone Funds"}
                  </div>
                  <Line1Icon
                    className={classNames(projectcss.all, sty.svg__swo8N)}
                    role={"img"}
                  />

                  <button
                    data-plasmic-name={"handleBankTransfer"}
                    data-plasmic-override={overrides.handleBankTransfer}
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      sty.handleBankTransfer
                    )}
                    ref={ref => {
                      $refs["handleBankTransfer"] = ref;
                    }}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__mz5T0
                      )}
                    >
                      {"Send Bank Transfer (ACH)"}
                    </div>
                  </button>
                </div>
              </div>
              <div
                data-plasmic-name={"figmaPaste3"}
                data-plasmic-override={overrides.figmaPaste3}
                className={classNames(projectcss.all, sty.figmaPaste3)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__jh75E
                  )}
                >
                  {"Powered by astrius"}
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"sideBarInstance"}
              data-plasmic-override={overrides.sideBarInstance}
              className={classNames(projectcss.all, sty.sideBarInstance)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__iIrc9)}>
                {renderPlasmicSlot({
                  defaultContents: "Social Media Marketing",
                  value: args.contractName,
                  className: classNames(sty.slotTargetContractName)
                })}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__w0W7B)}>
                {renderPlasmicSlot({
                  defaultContents: "$300.00",
                  value: args.amount,
                  className: classNames(sty.slotTargetAmount)
                })}
              </div>
              <div
                data-plasmic-name={"closeButton"}
                data-plasmic-override={overrides.closeButton}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.closeButton
                )}
              >
                {"X"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mCom4
                )}
              >
                {"Qty 1"}
              </div>
              <div
                data-plasmic-name={"milestoneNameStack"}
                data-plasmic-override={overrides.milestoneNameStack}
                className={classNames(projectcss.all, sty.milestoneNameStack)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Milestone 2: Audit and Analysis",
                  value: args.milestoneName,
                  className: classNames(sty.slotTargetMilestoneName)
                })}
              </div>
              <Line1Icon
                className={classNames(projectcss.all, sty.svg__pmhZr)}
                role={"img"}
              />

              <div
                data-plasmic-name={"viewContract"}
                data-plasmic-override={overrides.viewContract}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.viewContract
                )}
              >
                {"View Contract"}
              </div>
              <Line1Icon
                data-plasmic-name={"lowerBar"}
                data-plasmic-override={overrides.lowerBar}
                className={classNames(projectcss.all, sty.lowerBar)}
                role={"img"}
              />

              <div
                data-plasmic-name={"downloadContract"}
                data-plasmic-override={overrides.downloadContract}
                className={classNames(projectcss.all, sty.downloadContract)}
              >
                <Layer11Icon
                  className={classNames(projectcss.all, sty.svg__n8Dfz)}
                  role={"img"}
                />

                <div className={classNames(projectcss.all, sty.freeBox__kalHv)}>
                  <IconIcon
                    className={classNames(projectcss.all, sty.svg___1DzNn)}
                    role={"img"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "goBackArrow",
    "goBackText",
    "sendButton",
    "sendText",
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  goBackArrow: ["goBackArrow"],
  goBackText: ["goBackText"],
  sendButton: ["sendButton", "sendText"],
  sendText: ["sendText"],
  previewBody: [
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "rectangle28",
    "figmaPaste2",
    "handleBankTransfer",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  companyName: ["companyName"],
  rectangle29: ["rectangle29", "figmaPaste", "viewDetails"],
  figmaPaste: ["figmaPaste", "viewDetails"],
  viewDetails: ["viewDetails"],
  rectangle28: ["rectangle28", "figmaPaste2", "handleBankTransfer"],
  figmaPaste2: ["figmaPaste2", "handleBankTransfer"],
  handleBankTransfer: ["handleBankTransfer"],
  figmaPaste3: ["figmaPaste3"],
  sideBarInstance: [
    "sideBarInstance",
    "closeButton",
    "milestoneNameStack",
    "viewContract",
    "lowerBar",
    "downloadContract"
  ],

  closeButton: ["closeButton"],
  milestoneNameStack: ["milestoneNameStack"],
  viewContract: ["viewContract"],
  lowerBar: ["lowerBar"],
  downloadContract: ["downloadContract"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicEscrowPaymentsPagePreviewAch__ArgProps,
          internalVariantPropNames:
            PlasmicEscrowPaymentsPagePreviewAch__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicEscrowPaymentsPagePreviewAch__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicEscrowPaymentsPagePreviewAch";
  } else {
    func.displayName = `PlasmicEscrowPaymentsPagePreviewAch.${nodeName}`;
  }
  return func;
}

export const PlasmicEscrowPaymentsPagePreviewAch = Object.assign(
  // Top-level PlasmicEscrowPaymentsPagePreviewAch renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    goBackArrow: makeNodeComponent("goBackArrow"),
    goBackText: makeNodeComponent("goBackText"),
    sendButton: makeNodeComponent("sendButton"),
    sendText: makeNodeComponent("sendText"),
    previewBody: makeNodeComponent("previewBody"),
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    viewDetails: makeNodeComponent("viewDetails"),
    rectangle28: makeNodeComponent("rectangle28"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    handleBankTransfer: makeNodeComponent("handleBankTransfer"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    sideBarInstance: makeNodeComponent("sideBarInstance"),
    closeButton: makeNodeComponent("closeButton"),
    milestoneNameStack: makeNodeComponent("milestoneNameStack"),
    viewContract: makeNodeComponent("viewContract"),
    lowerBar: makeNodeComponent("lowerBar"),
    downloadContract: makeNodeComponent("downloadContract"),
    // Metadata about props expected for PlasmicEscrowPaymentsPagePreviewAch
    internalVariantProps: PlasmicEscrowPaymentsPagePreviewAch__VariantProps,
    internalArgProps: PlasmicEscrowPaymentsPagePreviewAch__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicEscrowPaymentsPagePreviewAch;
/* prettier-ignore-end */
